(function () {
  'use strict';

  var selectedVariants = {};
  var popupShownFor = {};

  // --- Helpers ---

  function formatEur(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function getPdpSection() {
    return document.querySelector('[data-zbp-pdp]');
  }

  // --- CTA button text update ---

  function updateCtaButton() {
    var section = getPdpSection();
    var hasSelection = Object.keys(selectedVariants).length > 0;

    // Calculate total discounted price
    var totalPrice = null;
    if (hasSelection && section) {
      var mainPrice = parseInt(section.dataset.zbpMainPrice || '0', 10);
      var discountPct = parseInt(section.dataset.zbpDiscountPct || '0', 10);
      var accessoryTotal = 0;
      Object.keys(selectedVariants).forEach(function (id) {
        var card = section.querySelector('[data-zbp-card][data-zbp-variant-id="' + id + '"]');
        if (card) accessoryTotal += parseInt(card.dataset.zbpPrice || '0', 10);
      });
      var savings = Math.round(accessoryTotal * discountPct / 100);
      totalPrice = formatEur(mainPrice + accessoryTotal - savings);
    }

    var buttons = [
      document.querySelector('[type="submit"].product-single__add-to-cart'),
      document.getElementById('sticky-add-to-cart'),
    ];

    buttons.forEach(function (btn) {
      if (!btn) return;

      if (!hasSelection) {
        if (btn.dataset.zbpOrigCta) {
          btn.innerHTML = btn.dataset.zbpOrigCta;
          delete btn.dataset.zbpOrigCta;
        }
        return;
      }

      if (!btn.dataset.zbpOrigCta) {
        btn.dataset.zbpOrigCta = btn.innerHTML;
      }

      btn.innerHTML = btn.dataset.zbpOrigCta + ' | ' + totalPrice;
    });
  }

  // --- Selection ---

  function syncCardState(variantId, selected) {
    document.querySelectorAll('[data-zbp-card][data-zbp-variant-id="' + variantId + '"]').forEach(function (card) {
      card.classList.toggle('zbp-card--selected', selected);
    });
  }

  // --- Event delegation ---

  function handleClick(event) {
    var card = event.target.closest('[data-zbp-card]');
    if (!card) return;

    if (event.target.closest('a')) return;

    var variantId = card.dataset.zbpVariantId;
    if (!variantId) return;

    var isSelected = card.classList.contains('zbp-card--selected');

    if (isSelected) {
      delete selectedVariants[variantId];
      syncCardState(variantId, false);
    } else {
      selectedVariants[variantId] = true;
      syncCardState(variantId, true);
    }

    updateCtaButton();
  }

  // --- Add the whole bundle in one call, then show the theme's confirmation ---

  // EUR→BGN conversion rate (mirrors snippets/dual-price-display.liquid).
  var EUR_TO_BGN = 1.95583;

  function formatBundlePrice(cents) {
    // Reuse theme.Shopify.formatMoney for the primary side so the output
    // honours shop.money_format; fall back if the theme helper isn't loaded.
    var eurStr;
    if (window.theme && window.theme.Shopify && window.theme.Shopify.formatMoney && window.theme.money_format) {
      eurStr = window.theme.Shopify.formatMoney(cents, window.theme.money_format);
    } else {
      eurStr = '€' + (cents / 100).toFixed(2);
    }

    // Dual-currency display is a BG-store-specific affordance ahead of the
    // Euro changeover. Gated by the per-store `dual_currency_display_enabled`
    // theme setting; when off, only the primary (EUR) amount is shown.
    var dualEnabled = !!(window.theme && window.theme.settings && window.theme.settings.dualCurrencyDisplayEnabled);
    if (!dualEnabled) {
      return eurStr;
    }

    var bgn = Math.round(cents * EUR_TO_BGN) / 100;
    var bgnFormat = (window.__T && window.__T.general && window.__T.general.currency && window.__T.general.currency.bgn_amount_format) || '{{amount}} лв.';
    return eurStr + ' / ' + bgnFormat.replace('{{amount}}', bgn.toFixed(2));
  }

  function escapeAttr(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/"/g, '&quot;')
      .replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function getFormMainItem(form) {
    var idInput = form.querySelector('input[name="id"]');
    var qtyInput = form.querySelector('input[name="quantity"]');
    var id = idInput ? parseInt(idInput.value, 10) : null;
    var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
    return id ? { id: id, quantity: qty } : null;
  }

  function cartProductRow(item) {
    var thumb = (item.featured_image && item.featured_image.url) || item.image || '';
    var title = item.product_title || item.title || '';
    var priceHtml = item.final_price < item.original_price
      ? '<p style="text-decoration:line-through;color:grey;margin-bottom:2px">' + formatBundlePrice(item.original_price) + '</p>' +
        '<p style="font-weight:bold;color:#c81853">' + formatBundlePrice(item.final_price) + '</p>'
      : '<p style="font-weight:bold">' + formatBundlePrice(item.final_price) + '</p>';
    return '<div class="cart-product">' +
        '<div class="cart-product__image"><img src="' + escapeAttr(thumb) + '" alt="' + escapeAttr(title) + '"/></div>' +
        '<div class="cart-product__content">' +
          '<p class="cart-product__content__title">' + escapeAttr(title) + '</p>' +
          priceHtml +
        '</div>' +
      '</div>';
  }

  // Build the theme's "added to cart" popup listing every item in the bundle.
  // showThemeModal also appends the gift-progress box from /cart.js automatically.
  function showAddedToCartModal(items) {
    if (!items.length || typeof showThemeModal !== 'function' || typeof theme === 'undefined') return false;
    var tick = (theme.icons && theme.icons.tick) || '';
    var strings = theme.strings || {};
    var routes = theme.routes || {};
    var html = [
      '<div id="added-to-cart" class="theme-modal theme-modal--small" role="dialog" aria-modal="true" aria-labelledby="added-to-cart-title">',
      '<div class="inner" style="top:25px;min-height:0;max-height:calc(100vh - 25px);overflow-y:auto;justify-content:flex-start">',
      '<a href="#" data-modal-close class="modal-close">&times;</a>',
      '<h4 id="added-to-cart-title">' + tick + (strings.productAddedToCart || 'Added to cart') + '</h4>',
      items.map(cartProductRow).join(''),
      '<p class="links">',
      '<a href="' + (routes.cart_url || '/cart') + '" class="button alt">' + (strings.viewCart || 'View cart') + '</a>',
      '<a href="' + (routes.checkout || '/checkout') + '" class="button button--checkout" [data-cc-checkout-button]>' + (strings.popupCheckout || 'Checkout') + '</a>',
      '</p>',
      '</div>',
      '</div>'
    ].join('');
    showThemeModal(html, 'added-to-cart', null);
    return true;
  }

  // Re-fetch the header cart summary so the counter reflects the new items.
  function refreshCartCount() {
    var url = window.location.origin + window.location.pathname + '?view=ajax';
    fetch(url)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('#site-control .cart:not(.nav-search)');
        var current = document.querySelector('#site-control .cart:not(.nav-search)');
        if (fresh && current) current.replaceWith(fresh);
      })
      .catch(function () {});
  }

  // Add the main item + the given accessories in a single /cart/add.js call.
  function addBundleToCart(form, accessoryIds, onSettled) {
    var items = [];
    var mainItem = getFormMainItem(form);
    if (mainItem) items.push(mainItem);
    (accessoryIds || []).filter(Boolean).forEach(function (id) {
      items.push({ id: parseInt(id, 10), quantity: 1 });
    });
    if (items.length === 0) { form.submit(); return; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed: ' + res.status);
        return res.json();
      })
      .then(function (data) {
        // Items are in the cart now — never fall back to a native re-add past here.
        if (onSettled) onSettled();
        var added = (data && data.items) || [];
        var shown = false;
        try {
          shown = showAddedToCartModal(added);
        } catch (err) {
          shown = false;
        }
        if (shown) refreshCartCount();
        else window.location.href = '/cart'; // couldn't show the popup; show the cart instead
      })
      .catch(function () {
        // Only reached if the add request itself failed.
        if (onSettled) onSettled();
        form.submit();
      });
  }

  function clearSelection() {
    Object.keys(selectedVariants).forEach(function (id) { syncCardState(id, false); });
    selectedVariants = {};
    updateCtaButton();
  }

  // --- Mobile carousel for popup ---

  function initCarousel(container, track, prevBtn, nextBtn) {
    var items = Array.from(track.children);
    var total = items.length;
    if (total === 0) return;

    if (total <= 1) {
      prevBtn.style.display = 'none';
      nextBtn.style.display = 'none';
      return;
    }

    var GAP = 12;
    // Card width = 62% of the carousel container, measured in JS to avoid
    // percentage flex-basis resolving against the unconstrained track width.
    var cardW = Math.round(container.offsetWidth * 0.62);
    items.forEach(function (li) { li.style.flex = '0 0 ' + cardW + 'px'; });

    // Prepend clone of last, append clone of first for seamless infinite loop
    var cloneLast = items[total - 1].cloneNode(true);
    var cloneFirst = items[0].cloneNode(true);
    cloneLast.setAttribute('aria-hidden', 'true');
    cloneFirst.setAttribute('aria-hidden', 'true');
    cloneLast.style.pointerEvents = 'none';
    cloneFirst.style.pointerEvents = 'none';
    cloneLast.style.flex = '0 0 ' + cardW + 'px';
    cloneFirst.style.flex = '0 0 ' + cardW + 'px';
    track.insertBefore(cloneLast, track.firstChild);
    track.appendChild(cloneFirst);

    // Start on the real first card (index 1, after the prepended clone)
    var currentIdx = 1;
    var transitioning = false;

    function getCardWidth() {
      return cardW;
    }

    function getTranslate(idx) {
      var cw = getCardWidth() || (container.offsetWidth * 0.72);
      var centerOffset = (container.offsetWidth - cw) / 2;
      return -(idx * (cw + GAP)) + centerOffset;
    }

    function go(idx, animate) {
      currentIdx = idx;
      track.style.transition = animate !== false
        ? 'transform 380ms cubic-bezier(0.4,0,0.2,1)'
        : 'none';
      track.style.transform = 'translateX(' + getTranslate(idx) + 'px)';
    }

    // After sliding to a clone, silently jump to the real counterpart
    track.addEventListener('transitionend', function () {
      var len = track.children.length; // total + 2
      if (currentIdx === 0) go(len - 2, false);
      else if (currentIdx === len - 1) go(1, false);
      transitioning = false;
    });

    prevBtn.addEventListener('click', function () {
      if (transitioning) return;
      transitioning = true;
      go(currentIdx - 1, true);
    });
    nextBtn.addEventListener('click', function () {
      if (transitioning) return;
      transitioning = true;
      go(currentIdx + 1, true);
    });

    var touchStartX = 0;
    track.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
      track.style.transition = 'none';
    }, { passive: true });

    track.addEventListener('touchmove', function (e) {
      var dx = e.touches[0].clientX - touchStartX;
      track.style.transform = 'translateX(' + (getTranslate(currentIdx) + dx) + 'px)';
    }, { passive: true });

    track.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - touchStartX;
      go(Math.abs(dx) > 40 ? (dx < 0 ? currentIdx + 1 : currentIdx - 1) : currentIdx, true);
    }, { passive: true });

    go(currentIdx, false);
  }

  // --- Bundle upsell popup ---

  function showBundlePopup(section, form) {
    var addLabel      = section.dataset.zbpPopupAdd      || 'Add';
    var addedLabel    = section.dataset.zbpPopupAdded    || 'Added';
    var continueLabel = section.dataset.zbpPopupContinue || 'Continue';
    var skipLabel     = section.dataset.zbpPopupSkip     || 'Skip, add without bundle';
    var headingText   = section.dataset.zbpPopupHeading  || '';

    var popupSelected = {}; // variantId → true for cards toggled on in this popup

    var overlay = document.createElement('div');
    overlay.className = 'zbp-popup-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('tabindex', '-1');

    var popup = document.createElement('div');
    popup.className = 'zbp-popup';

    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'zbp-popup-close';
    closeBtn.setAttribute('aria-label', 'Close');
    closeBtn.innerHTML = '&times;';
    popup.appendChild(closeBtn);

    // Custom popup heading (different from the inline PDP heading)
    var headingEl = document.createElement('h2');
    headingEl.className = 'zbp-heading';
    headingEl.textContent = headingText;
    popup.appendChild(headingEl);

    // Clone card list; strip toggles, add Добави/Добавено toggle buttons
    var cardHandlers = [];
    var origCardList = section.querySelector('.zbp-card-list');
    var carouselEl = null;
    if (origCardList) {
      var cardListClone = origCardList.cloneNode(true);
      cardListClone.querySelectorAll('[data-zbp-card]').forEach(function (card) {
        card.removeAttribute('data-zbp-card'); // prevent global click handler
        var toggle = card.querySelector('.zbp-card-toggle');
        if (toggle) toggle.remove();

        var variantId = card.dataset.zbpVariantId;
        if (variantId && !card.classList.contains('zbp-card--unavailable')) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'zbp-popup-card-btn';
          btn.textContent = addLabel;
          card.appendChild(btn);
          cardHandlers.push({ btn: btn, variantId: variantId, imageWrap: card.querySelector('.zbp-card-image-wrap') });
        }
      });

      if (window.innerWidth <= 640) {
        // Mobile: wrap in a swipeable carousel
        carouselEl = document.createElement('div');
        carouselEl.className = 'zbp-carousel';

        var prevArrowEl = document.createElement('button');
        prevArrowEl.type = 'button';
        prevArrowEl.className = 'zbp-carousel-arrow zbp-carousel-arrow--prev';
        prevArrowEl.setAttribute('aria-label', 'Previous');
        prevArrowEl.innerHTML = '&#8249;';

        var nextArrowEl = document.createElement('button');
        nextArrowEl.type = 'button';
        nextArrowEl.className = 'zbp-carousel-arrow zbp-carousel-arrow--next';
        nextArrowEl.setAttribute('aria-label', 'Next');
        nextArrowEl.innerHTML = '&#8250;';

        cardListClone.classList.add('zbp-carousel-track');
        carouselEl.appendChild(prevArrowEl);
        carouselEl.appendChild(cardListClone);
        carouselEl.appendChild(nextArrowEl);
        popup.appendChild(carouselEl);
      } else {
        popup.appendChild(cardListClone);
      }
    }

    // Actions: Продължи (primary) + Продължи без комплект (skip)
    var actions = document.createElement('div');
    actions.className = 'zbp-popup-actions';

    var continueBtn = document.createElement('button');
    continueBtn.type = 'button';
    continueBtn.className = 'zbp-popup-continue button';
    continueBtn.textContent = continueLabel;
    continueBtn.disabled = true; // nothing selected yet; Skip covers the no-accessory case

    var skipBtn = document.createElement('button');
    skipBtn.type = 'button';
    skipBtn.className = 'zbp-popup-skip';
    skipBtn.textContent = skipLabel;

    actions.appendChild(continueBtn);
    actions.appendChild(skipBtn);
    popup.appendChild(actions);

    overlay.appendChild(popup);
    document.body.appendChild(overlay);
    document.body.classList.add('zbp-popup-open');
    overlay.focus();

    if (carouselEl) initCarousel(carouselEl, cardListClone, prevArrowEl, nextArrowEl);

    var finished = false;

    function teardown() {
      overlay.remove();
      document.body.classList.remove('zbp-popup-open');
      document.removeEventListener('keydown', handleKey);
    }

    // Close the popup, add any chosen accessories, then hand the main-item add
    // back to the theme so its native "added to cart" drawer is shown.
    function finish(extraIds) {
      if (finished) return;
      finished = true;
      teardown();
      addBundleToCart(form, extraIds);
    }

    function handleKey(e) {
      if (e.key === 'Escape') finish([]);
    }

    closeBtn.addEventListener('click', function () { finish([]); });
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) finish([]);
    });
    document.addEventListener('keydown', handleKey);

    // Card toggle: Добави ↔ Добавено
    // Updates every button for this variantId in the overlay (real card + any clone)
    function syncVariantButtons(variantId, isAdded) {
      overlay.querySelectorAll('[data-zbp-variant-id="' + variantId + '"] .zbp-popup-card-btn').forEach(function (b) {
        b.textContent = isAdded ? addedLabel : addLabel;
        b.classList.toggle('zbp-popup-card-btn--added', isAdded);
        b.blur();
      });
    }

    cardHandlers.forEach(function (item) {
      function toggleCard() {
        if (popupSelected[item.variantId]) {
          delete popupSelected[item.variantId];
          syncVariantButtons(item.variantId, false);
        } else {
          popupSelected[item.variantId] = true;
          syncVariantButtons(item.variantId, true);
        }
        continueBtn.disabled = Object.keys(popupSelected).length === 0;
      }
      item.btn.addEventListener('click', toggleCard);
      if (item.imageWrap) item.imageWrap.addEventListener('click', toggleCard);
    });

    // Продължи: add the chosen accessories, then the theme adds the main item
    continueBtn.addEventListener('click', function () {
      finish(Object.keys(popupSelected));
    });

    // Skip: add only the main item (via the theme)
    skipBtn.addEventListener('click', function () {
      finish([]);
    });
  }

  // --- PDP: intercept main form submit ---

  function interceptMainForm() {
    var form = document.getElementById('product-form');
    if (!form) return;

    var submitBtn = form.querySelector('[type="submit"].product-single__add-to-cart');
    var origText = submitBtn ? submitBtn.textContent.trim() : null;

    form.addEventListener('submit', function (event) {
      var variantIds = Object.keys(selectedVariants);
      var section = getPdpSection();

      if (variantIds.length === 0) {
        // var productId = section && section.dataset.zbpProductId;
        // if (section && productId && !popupShownFor[productId]) {
        //   // First add-to-cart with no accessories: offer the bundle upsell popup.
        //   // The main item is added in one call once the popup is resolved.
        //   event.preventDefault();
        //   event.stopImmediatePropagation();
        //   popupShownFor[productId] = true;
        //   showBundlePopup(section, form);
        // }
        return;
      }

      // Accessories chosen inline: add the main item + accessories in one call,
      // then show the theme's confirmation popup listing the whole bundle.
      event.preventDefault();
      event.stopImmediatePropagation();
      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = '…'; }
      addBundleToCart(form, variantIds, function () {
        if (submitBtn) {
          submitBtn.disabled = false;
          if (origText) submitBtn.textContent = origText;
        }
        clearSelection(); // reset the PDP selection now the bundle is in the cart
      });
    }, true);
  }

  // --- Cart page ---

  // The cart cards live inside the page's main cart <form>, so they use a
  // plain button + data attributes (not a nested <form>, which is invalid HTML)
  // and add via /cart/add.js on click.
  function handleCartAdd(event) {
    var trigger = event.target.closest('[data-zbp-add-form]');
    if (!trigger) return;

    event.preventDefault();

    var variantId = parseInt(trigger.dataset.zbpVariantId, 10);
    if (!variantId) return;

    var button = trigger.querySelector('.zbp-card-add');
    var origBtnText = button ? button.textContent : null;
    if (button) {
      button.disabled = true;
      button.textContent = '…';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error(res.status);
        return res.json();
      })
      .then(function () {
        window.location.reload();
      })
      .catch(function () {
        if (button) {
          button.disabled = false;
          if (origBtnText) button.textContent = origBtnText;
        }
      });
  }

  // --- Init ---

  function init() {
    if (getPdpSection()) {
      document.addEventListener('click', handleClick);
      interceptMainForm();
    }
    if (document.querySelector('[data-zbp-cart]')) {
      document.addEventListener('click', handleCartAdd);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
